import React from 'react';
import { Mail, MessageCircle, HelpCircle, ExternalLink } from 'lucide-react';
import Button from '../../../components/ui/Button';

const SupportContact = () => {
  const handleEmailSupport = () => {
    window.location.href = 'mailto:support@mybodytoday1.com?subject=Premium Subscription Support';
  };

  const handleOpenHelp = () => {
    // Navigate to help/settings page
    window.open('/settings-and-privacy', '_blank');
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg shadow-md p-6 border border-blue-200">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
          <HelpCircle className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-900 mb-2">Need Help Getting Started?</h3>
          <p className="text-gray-700 mb-4">
            Our Premium support team is here to help you make the most of your subscription. 
            Get faster response times and dedicated assistance.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button 
              onClick={handleEmailSupport}
              variant="default"
              size="sm"
              iconName="Mail"
              iconPosition="left"
            >
              Email Support
            </Button>
            <Button 
              onClick={handleOpenHelp}
              variant="outline"
              size="sm"
              iconName="ExternalLink"
              iconPosition="left"
            >
              Visit Help Center
            </Button>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-blue-200">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div className="flex items-center gap-2">
            <Mail className="w-4 h-4 text-blue-600" />
            <span className="text-gray-700">
              <span className="font-medium">Email:</span> support@mybodytoday1.com
            </span>
          </div>
          <div className="flex items-center gap-2">
            <MessageCircle className="w-4 h-4 text-blue-600" />
            <span className="text-gray-700">
              <span className="font-medium">Response Time:</span> Within 24 hours
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportContact;